<template>
  <v-card>
    <v-menu
      min-width="300px"
      absolute
      offset-y
      :close-on-content-click="!bypassClickCloseMenu"
      :position-x="xMenu"
      :position-y="yMenu"
      :transition="null"
      :value="showMenu"
      @input="handleInput"
    >
      <template v-if="showMenu">
        <v-list dense>
          <v-list-item
            v-if="menuItem.title && selectedItems.length < 2"
            :disabled="
              menuItem.status !== 'CONVERTING' &&
              menuItem.status !== 'CONVERTED'
            "
            @click="handleEditVideo(menuItem), $emit('keepSearchOpen')"
          >
            <v-list-item-icon>
              <v-icon>mdi-eye-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{
              $t('message.pages.videosDataTable.menu.open')
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="menuItem.name && selectedItems.length < 2"
            @click="handleGoToFolder(menuItem), $emit('keepSearchOpen')"
          >
            <v-list-item-icon>
              <v-icon>mdi-eye-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{
              $t('message.pages.videosDataTable.menu.open')
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="selectedItems.length === 1"
            @click="handleLogs(menuItem)"
          >
            <v-list-item-icon>
              <v-icon>mdi-history</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{
              $t('message.pages.historyModal.history')
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="menuItem.title && selectedItems.length < 2"
            :disabled="
              menuItem.status !== 'CONVERTING' &&
              menuItem.status !== 'CONVERTED'
            "
            @click="handleOpenNewTab(), $emit('keepSearchOpen')"
          >
            <v-list-item-icon>
              <v-icon>mdi-open-in-new</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{
              $t('message.pages.videosDataTable.menu.openInNew')
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="menuItem.name && selectedItems.length < 2"
            @click="handleOpenNewTab(), $emit('keepSearchOpen')"
          >
            <v-list-item-icon>
              <v-icon>mdi-open-in-new</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{
              $t('message.pages.videosDataTable.menu.openInNew')
            }}</v-list-item-title>
          </v-list-item>
          <v-divider class="my-1" v-if="selectedItems.length < 2" />
          <v-list-item
            v-if="menuItem.name && selectedItems.length < 2 && hasEditVideoPerm"
            @click="handleEditFolder(menuItem), $emit('keepSearchOpen')"
          >
            <v-list-item-icon>
              <v-icon>mdi-pencil</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{
              $t('message.pages.videosDataTable.menu.rename')
            }}</v-list-item-title>
          </v-list-item>

          <v-menu
            v-if="menuItem.title && selectedItems.length < 2"
            top
            offset-x
            open-on-hover
          >
            <template v-slot:activator="{ on, attrs }">
              <v-list-item
                v-bind="attrs"
                v-on="on"
                dense
                :disabled="disableVideoCopyLinks"
                @click="handleEmbedCopy(), $emit('keepSearchOpen')"
              >
                <v-list-item-icon>
                  <v-icon>mdi-xml</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  <v-row
                    no-gutters
                    class="d-flex flex-row align-center justify-space-between"
                  >
                    <span>{{
                      $t('message.pages.videosDataTable.menu.copyEmbed')
                    }}</span>
                    <template v-if="!menuItem.video_source">
                      <span>({{ embedTrademark }})</span>
                      <v-icon color="grey lighten-1" class="ml-2">
                        mdi-chevron-right
                      </v-icon>
                    </template>
                  </v-row>
                </v-list-item-title>
              </v-list-item>
            </template>

            <v-list v-if="!menuItem.video_source" dense>
              <template v-for="(option, i) in embedOptions">
                <v-list-item
                  :key="`item-options-${i}`"
                  dense
                  @click="
                    setEmbed(option.value, menuItem), $emit('keepSearchOpen')
                  "
                >
                  <v-list-item-title>{{ option.text }}</v-list-item-title>
                </v-list-item>
                <template v-if="i === 0">
                  <v-list-item
                    :key="`item-custom-${i}`"
                    dense
                    @click="
                      openCustomizeEmbed(menuItem), $emit('keepSearchOpen')
                    "
                  >
                    <v-list-item-title>{{
                      $t('message.customize')
                    }}</v-list-item-title>
                  </v-list-item>
                  <v-divider :key="`divider-${i}`" class="my-1" />
                </template>
              </template>
            </v-list>
          </v-menu>
          <v-list-item
            v-if="
              menuItem.title &&
              selectedItems.length < 2 &&
              !isExternalSourceVideo
            "
            :disabled="disableVideoCopyLinks"
            @click="handleCopyHLSEmbed(menuItem), $emit('keepSearchOpen')"
          >
            <v-list-item-icon>
              <v-icon>mdi-link</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{
              $t('message.pages.videosDataTable.menu.copyHLS')
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="menuItem && selectedItems.length < 2 && hasEditVideoPerm"
            :disabled="drmGroupsLoading || !isDrmActive"
            @click="handleDrmMenu(menuItem), $emit('keepSearchOpen')"
          >
            <v-list-item-icon>
              <v-icon>mdi-lock-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Configurações de segurança</v-list-item-title>
          </v-list-item>
          <v-divider
            class="my-1"
            v-if="
              selectedItems.length < 2 && menuItem.title && hasEditVideoPerm
            "
          />
          <v-list-item
            v-if="selectedItems.length < 2 && menuItem.video_external_id"
            @click="handleRenameVideo(menuItem), $emit('keepSearchOpen')"
          >
            <v-list-item-icon>
              <v-icon>mdi-pencil</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{
              $t('message.pages.videosDataTable.menu.rename')
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            @click="handleMoveFiles(), $emit('keepSearchOpen')"
            v-if="hasEditVideoPerm"
          >
            <v-list-item-icon>
              <v-icon>mdi-folder-move-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              <span v-if="selectedItems.length > 1">
                {{
                  $t('message.moveFiles', {
                    count: selectedItems.length,
                  })
                }}
              </span>
              <span v-else>
                {{ $t('message.move') }}
              </span>
            </v-list-item-title>
          </v-list-item>
          <template v-if="!isExternalSourceVideo && hasEditVideoPerm">
            <v-list-item
              v-if="menuItem.title && selectedItems.length < 2"
              :disabled="menuItem.status !== 'CONVERTED'"
              @click="handleDuplicateVideo(menuItem), $emit('keepSearchOpen')"
            >
              <v-list-item-icon>
                <v-icon>mdi-content-duplicate</v-icon>
              </v-list-item-icon>
              <v-list-item-title
                >{{ $t('message.duplicate') }}
              </v-list-item-title>
            </v-list-item>
            <!-- disabled vide download when imported-->
            <template v-if="checkIfIsImport(menuItem)">
              <v-tooltip left :disabled="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item
                    link
                    v-bind="attrs"
                    v-on="on"
                    style="opacity: 0.5"
                  >
                    <v-row class="align-center">
                      <v-col
                        :cols="selectedItems.length < 2 ? 8 : 10"
                        class="align-center d-flex flex-row"
                      >
                        <v-list-item-icon>
                          <v-icon>mdi-download</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{
                          $t('message.download')
                        }}</v-list-item-title>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </template>
                <div style="width: 300px">
                  <span>{{ $t('message.disabledDownloadTooltip') }}</span>
                </div>
              </v-tooltip>
            </template>
            <v-list-item
              v-else-if="
                !checkIfIsImport(menuItem) &&
                menuItem.title &&
                selectedItems.length < 2 &&
                disableVideoCopyLinks &&
                hasEditVideoPerm
              "
              disabled
            >
              <v-list-item-icon>
                <v-icon>mdi-download</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{
                $t('message.download')
              }}</v-list-item-title>
            </v-list-item>
            <MenuItemDownload
              v-else-if="
                menuItem.title &&
                selectedItems.length < 2 &&
                hasEditVideoPerm &&
                !checkIfIsImport(menuItem)
              "
              :value="showMenu"
              :video="menuItem"
              :has-recuo="false"
              :video-id="menuItem.id"
              :fetch-on-mount="false"
              @click.native="bypassClickCloseMenu = true"
              @fetched="bypassClickCloseMenu = false"
              @submit="
                $emit('setDownloadServer', $event.downloadServer)
                qualityToBeDownloaded = $event.qualityToBeDownloaded
                $nextTick(() => $refs.downloadForm.submit())
              "
            />
          </template>
          <!-- list AI -->
          <v-divider class="my-1" v-if="canSeePlanInfo" />
          <template v-if="canSeePlanInfo">
            <v-tooltip left :disabled="!!selectedItems.length">
              <template v-slot:activator="{ on, attrs }">
                <v-list-item
                  link
                  @click="handleOpenSubModal"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-row class="align-center">
                    <v-col
                      :cols="selectedItems.length < 2 ? 8 : 10"
                      class="align-center d-flex flex-row"
                    >
                      <!-- subtitle -->
                      <v-list-item-icon>
                        <v-icon>mdi-closed-caption</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>
                        <span v-if="selectedItems.length > 1">
                          {{ $t('message.ai.subtitles.generateSubtitles') }}
                        </span>
                        <span v-else>
                          {{ $t('message.ai.subtitles.generateSubtitle') }}
                        </span>
                      </v-list-item-title>
                    </v-col>
                    <v-col v-if="selectedItems.length < 2" cols="1"> </v-col>
                    <v-col
                      v-if="selectedItems.length < 2"
                      cols="3"
                      class="text-end pa-0"
                    >
                      <span class="sectionStyle align-center">{{
                        $t('message.ai.ai')
                      }}</span>
                    </v-col>
                  </v-row>
                </v-list-item>
              </template>
              <span>{{ $t('message.ai.subtitles.batchTooltip') }}</span>
            </v-tooltip>
            <!-- dubbing -->
            <v-tooltip left :disabled="!!selectedItems.length">
              <template v-slot:activator="{ on, attrs }">
                <v-list-item
                  link
                  @click="handleOpenDubModal"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-row class="align-center">
                    <v-col
                      :cols="selectedItems.length < 2 ? 8 : 10"
                      class="align-center d-flex flex-row"
                    >
                      <v-list-item-icon
                        style="
                          max-width: 24px !important;
                          max-height: 24px !important;
                        "
                      >
                        <simple-svg
                          :src="svgDataUrl_vMenu"
                          fill-class-name="fill-color"
                          width="24px"
                          height="24px"
                          :fill="
                            $vuetify.theme.dark ? 'white' : 'rgba(0,0,0,0.54)'
                          "
                        />
                      </v-list-item-icon>
                      <v-list-item-title>
                        <span v-if="selectedItems.length > 1">
                          {{ $t('message.ai.dubbings.generateDubbings') }}
                        </span>
                        <span v-else>
                          {{ $t('message.ai.dubbings.generateDubbing') }}
                        </span>
                      </v-list-item-title>
                    </v-col>
                  </v-row>
                </v-list-item>
              </template>
              <span>{{ $t('message.ai.dubbings.batchTooltip') }}</span>
            </v-tooltip>
          </template>
          <v-divider class="my-1" />
          <!-- list AI -->
          <v-list-item
            v-if="hasEditVideoPerm"
            @click="
              handleCheckIfCanDeleteItem(menuItem)
                ? null
                : handleRemoveItem(menuItem)
            "
            v-ripple="{ class: 'error--text' }"
            :disabled="menuItem.status === 'BLOCKED'"
          >
            <v-list-item-icon>
              <v-icon
                :color="
                  handleCheckIfCanDeleteItem(menuItem) ? 'grey' : '#f44336'
                "
                >mdi-delete</v-icon
              >
            </v-list-item-icon>
            <v-list-item-title
              :class="
                handleCheckIfCanDeleteItem(menuItem)
                  ? 'grey--text'
                  : 'danger-remove'
              "
            >
              <span v-if="selectedItems.length > 1">
                {{
                  $t('message.pages.video.defaultVideos.removeItems', {
                    count: selectedItems.length,
                  })
                }}
              </span>
              <span v-else>
                {{ $t('message.remove') }}
              </span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
        <form
          ref="downloadForm"
          method="post"
          :action="downloadUrl"
          style="display: none"
        >
          <input
            ref="downloadInput"
            name="Authorization"
            :value="authToken"
            type="hidden"
          />
        </form>
      </template>
    </v-menu>
    <v-dialog v-model="showMenuEmbed" width="600px">
      <embed-video
        v-if="mustShowEmbedModal"
        :openFromVideoList="true"
        :videoId="videoId"
        :showMenuEmbed="showMenuEmbed"
        :showMenuPosition="menuPosition"
        :startTime="embedVideo.startTime"
        :timeVideo="timeVideo"
        :embedSelectedProp="embedSelected"
        :fetching="fetching"
        :video="video"
        :isExternalSourceVideo="isExternalSourceVideo"
        @start-time="embedVideo.startTime = $event"
        @showEmbed="(val) => (showMenuEmbed = val)"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import downloadUrlMixin from '@/utils/downloadUrl.mixin.js'
import MenuItemDownload from '@/components/MenuItemDownload.vue'
import embedOptionOrientations from '@/utils/embedOptionOrientations.js'
import Storage from '@/utils/Storage'
import i18n from '@/translations/lang'
import { mapMutations, mapGetters } from 'vuex'
import { embedOptions as platformsOfEmbed } from '@/utils/embedOptions.js'
import embedCode from '@/utils/embedCode.mixin.js'
import EmbedVideo from '@/components/EmbedVideo.vue'

export default {
  data: () => ({
    bypassClickCloseMenu: false,
    embedOptionOrientations,
    embedTrademark:
      Storage.getItem('embedType') ??
      i18n.t('message.pages.videoEditModal.embedConfiguration.default'),
    qualityToBeDownloaded: null,
    showMenuEmbed: null,
    mustShowEmbedModal: null,
    video: {},
    timeVideo: 0,
    fetching: false,
    embedVideo: {
      width: 720,
      height: 360,
      startTimeCheckbox: false,
      startTime: '00:00',
    },
    embedCode: {
      useMenuItem: true,
    },
    menuPosition: {
      x: 1920,
      y: 72,
    },
    embedSelected: '',
    svgContent_vMenu: null,
  }),
  components: {
    EmbedVideo,
    MenuItemDownload,
  },
  mixins: [downloadUrlMixin, embedCode],
  props: {
    xMenu: {
      type: Number,
      required: true,
    },
    yMenu: {
      type: Number,
      required: true,
    },
    showMenu: {
      required: true,
    },
    menuItem: {
      required: true,
    },
    selectedItems: {
      type: Array,
      required: true,
    },
    downloadServer: {
      required: true,
    },
    drmGroupsLoading: {
      type: Boolean,
      required: true,
    },
    drmGroups: {
      required: true,
    },
    isDrmActive: {
      type: Boolean,
      required: true,
    },
  },
  async created() {
    try {
      const svgUrl = require('@/assets/dubbing.svg')
      const response = await fetch(svgUrl)
      const svgText = await response.text()
      this.svgContent_vMenu = svgText
    } catch (error) {
      console.error('Error to loading svg:', error)
    }
  },
  computed: {
    ...mapGetters('user', ['canSeePlanInfo']),
    videoId() {
      return this.menuItem.id
    },
    hasSomeDisabledVideo() {
      if (
        this.selectedItems.length &&
        this.selectedItems.some((item) => item.status === 'BLOCKED')
      ) {
        return true
      }
      return false
    },
    aspectRatio() {
      const { width, height } = this.menuItem
      let ratio = height / width
      if (Number.isNaN(ratio)) {
        ratio = 9 / 16
      }
      return `${ratio * 100}%`
    },
    disableVideoCopyLinks() {
      return this.menuItem.status === 'DRAFT'
    },
    embedOptions() {
      const [general] = platformsOfEmbed.filter(
        ({ value }) => value === 'general'
      )
      const rest = platformsOfEmbed.filter(({ value }) => value !== 'general')
      const sorted = rest.sort((a, b) => a.value.localeCompare(b.value))
      return [general, ...sorted]
    },
    isExternalSourceVideo() {
      return this.menuItem
        ? this.menuItem.hasOwnProperty('video_source')
        : false
    },
    hasEditVideoPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-video') ?? false
      )
    },
    svgDataUrl_vMenu() {
      return `data:image/svg+xml;utf8,${encodeURIComponent(
        this.svgContent_vMenu
      )}`
    },
  },
  watch: {
    showMenu: function () {
      this.$root.$emit('changeEmbed')
      let embedStored = Storage.getItem('embedType')
        ? Storage.getItem('embedType')
        : 'general'

      if (Storage.getItem('embedType')) {
        let embedOptionTrademark = this.embedOptions.map((val) => val.value)
        this.embedTrademark =
          this.embedOptions[embedOptionTrademark.indexOf(embedStored)].text
      } else {
        this.embedTrademark = embedStored
      }
    },
    showMenuEmbed(val) {
      if (val === false) this.$root.$emit('VideoEmbedModalHasClosed')
    },
  },
  methods: {
    ...mapMutations('user', ['UPDATE_ROUTED_VIDEO', 'UPDATE_GLOBAL_SNACKBAR']),
    checkIfIsImport(menuItem) {
      if (!menuItem.description) return
      const desc = menuItem.description
      let val = desc.includes('hotmart') || desc.includes('vimeo')
      return val
    },
    handleCheckIfCanDeleteItem(menuItem) {
      return menuItem.status === 'BLOCKED' || this.hasSomeDisabledVideo
    },
    handleInput(event) {
      if (!this.bypassClickCloseMenu) {
        this.$emit('setShowMenu', event)
      }
    },
    async openCustomizeEmbed(menuItem) {
      this.menuPosition = {
        link: {
          x: window.innerWidth / 2 - 300,
          y: 140,
        },
        embed: {
          x: window.innerWidth / 2 - 300,
          y: 140,
        },
        dots: {
          x: 1500,
          y: 140,
        },
      }
      this.mustShowEmbedModal = null
      this.video = menuItem
      this.timeVideo = menuItem.length ?? 0
      this.fetching = true
      this.$emit('setShowMenu', false)
      this.showMenuEmbed = true
      setTimeout(
        function () {
          this.mustShowEmbedModal = true
        }.bind(this)
      )
      this.fetchEmbedVideo()
    },
    async fetchEmbedVideo() {
      this.fetching = true
      Storage.setItem('width', this.embedVideo.width)
      Storage.setItem('height', this.embedVideo.height)
      let storageEmbedOption = Storage.getItem('embedType')
      let embedOptionsValue = this.embedOptions.map((el) => el.value)
      let storageIndex = embedOptionsValue.indexOf(storageEmbedOption)
      if (storageIndex !== -1) {
        this.embedSelected = this.embedOptions[storageIndex].value
      } else {
        this.embedSelected = this.embedOptions[0].value
      }
      Storage.setItem('embedType', this.embedSelected)
      let pullzoneValue = Storage.getItem(
        `pullzone-${this.$store.state.user.userInfo.sub ?? this.getSubKey()}`
      )
      this.userPullzoneName = pullzoneValue
      this.authToken = Storage.getItem('accessToken')
      this.$root.$on(
        'changeEmbed',
        function () {
          this.embedSelected = Storage.getItem('embedType')
            ? Storage.getItem('embedType')
            : i18n.t('message.pages.videoEditModal.embedConfiguration.default')
        }.bind(this)
      )
      this.fetching = false
    },
    handleRemoveItem(item) {
      if (this.selectedItems.length) {
        this.$root.$emit('deleteVideoModal', [...this.selectedItems])
      } else {
        let videos = []
        videos.push(item)
        this.$root.$emit('deleteVideoModal', [...videos])
      }
      this.$root.$emit('isAnyOtherModal', true)
    },
    handleDuplicateVideo(item) {
      this.$root.$emit('duplicateVideo', item.id)
    },
    handleDrmMenu(item) {
      this.$root.$emit('drmModalDashboard', {
        item: item,
        groups: this.drmGroups,
      })
      this.$root.$emit('isAnyOtherModal', true)
    },
    handleMoveFiles() {
      this.$root.$emit('isAnyOtherModal', true)

      if (this.selectedItems.length) {
        this.$root.$emit('moveModal', this.selectedItems)
        return
      }
      let arr = []
      arr.push(this.menuItem)
      this.$root.$emit('moveModal', arr)
    },
    handleEmbedCopy() {
      if (this.isExternalSourceVideo) this.handleShowLink(this.embed)
      else if (this.isExternalIdEmbed)
        this.handleCopyExternalIdEmbed(this.menuItem)
      else if (this.srcEmbed) this.handleCopySrcEmbed(this.menuItem)
      else if (this.codeEmbed) this.handleCopyCodeEmbed(this.menuItem)
      else if (this.hlsEmbed) this.handleCopyHLSEmbed(this.menuItem)
      else this.handleShowLink(this.embed)
    },
    handleCopyHLSEmbed(video) {
      let hls = `https://b-${video.pullzone_name}.tv.pandavideo.com.br/${video.video_external_id}/playlist.m3u8`
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.embedHlsCopiedToClipboard'),
      })
      navigator.clipboard.writeText(`${hls}`)
    },
    handleCopyCodeEmbed(video) {
      const code = video.id
      const open = true
      const text = i18n.t('message.embedCodeCopiedToClipboard')

      this.UPDATE_GLOBAL_SNACKBAR({ open, text })
      navigator.clipboard.writeText(`${code}`)
    },
    handleCopySrcEmbed(video) {
      const src = video.video_player
      const open = true
      const text = i18n.t('message.embedSrcCopiedToClipboard')

      this.UPDATE_GLOBAL_SNACKBAR({ open, text })
      navigator.clipboard.writeText(`${src}`)
    },
    handleCopyExternalIdEmbed(video) {
      const src = video.video_external_id
      const open = true
      const text = i18n.t('message.embedSrcCopiedToClipboard')
      this.UPDATE_GLOBAL_SNACKBAR({ open, text })
      navigator.clipboard.writeText(`${src}`)
    },
    handleShowLink(item) {
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.copiedToClipboard'),
      })
      navigator.clipboard.writeText(`${item}`)
    },
    handleOpenNewTab() {
      let routeData = {}
      if (this.menuItem.title) {
        routeData = this.$router.resolve({
          name: 'VideoPage',
          params: { id: this.menuItem.id },
        })
      }
      if (this.menuItem.name) {
        routeData = this.$router.resolve({
          name: 'Folders',
          params: { id: this.menuItem.id },
        })
      }
      window.open(routeData.href, '_blank')
    },
    handleEditFolder(folder) {
      this.$root.$emit('folderModal', { ...folder, edit: true })
    },
    handleRenameVideo(video) {
      this.$root.$emit('videoModalRename', { ...video, edit: true })
    },
    handleEditVideo(video) {
      this.UPDATE_ROUTED_VIDEO({ ...video })
      this.$router.push({ name: 'VideoPage', params: { id: video.id } })
    },
    handleGoToFolder(item) {
      this.$router.push({ name: 'Folders', params: { id: item.id } })
    },
    handleLogs(item) {
      this.$root.$emit('openModalItemLogs', item)
    },
    setEmbed(option, videoItem) {
      const optionDefault = i18n
        .t('message.pages.videoEditModal.embedConfiguration.default')
        .toLowerCase()

      option = option.toLowerCase()
      const externalOption = this.isExternalSourceVideo ? option : false

      if (option === optionDefault) {
        option = this.embedSelected = 'general'
      }

      const [selectedOption] = this.embedOptions.filter(
        ({ value }) => value === option
      )

      if (externalOption) option = optionDefault

      const isExternalIdEmbed = ['123tapronto']
      const isSrcEmbed = [
        'cademi',
        'engaged',
        'ensinio',
        'monetizze',
        'membertizze',
        'ticto',
      ]
      const isCodeEmbed = ['entrega-digital', 'creators-land']
      const isHLSEmbed = ['xgrow', 'greatpages', 'minervaead']
      const isRadioActiveFalse = Object.keys(this.embedOptionOrientations)
      const isRadioActiveTrue = this.embedOptions
        .map(({ value }) => {
          if (
            ![...isHLSEmbed, ...isRadioActiveFalse, 'general'].includes(value)
          )
            return value
        })
        .filter(Boolean)

      this.video = {}
      this.fetching = true
      this.$emit('setShowMenu', false)
      this.hlsEmbed = false
      this.codeEmbed = false
      this.srcEmbed = false
      this.embedSelected = option
      this.embedTrademark = selectedOption.text

      if (isExternalIdEmbed.includes(option)) {
        this.externalIdEmbed = true
        if (videoItem) this.handleCopyExternalIdEmbed(videoItem)
      } else if (isSrcEmbed.includes(option)) {
        this.srcEmbed = true
        if (videoItem) this.handleCopySrcEmbed(videoItem)
      } else if (isCodeEmbed.includes(option)) {
        this.codeEmbed = true
        if (videoItem) this.handleCopyCodeEmbed(videoItem)
      } else if (isHLSEmbed.includes(option)) {
        this.hlsEmbed = true
        this.radioActive = 1

        if (videoItem) this.handleCopyHLSEmbed(videoItem)
      } else {
        if (isRadioActiveTrue.includes(option)) {
          this.videoCustomSize = true
          this.radioActive = 1
        } else if (isRadioActiveFalse.includes(option)) {
          const orientation = this.isLandscapeOrientation
            ? 'landscape'
            : 'portrait'
          const { width, height } =
            this.embedOptionOrientations[option][orientation]

          this.videoCustomSize = false
          this.radioActive = 0

          this.embedVideo.width = width
          this.embedVideo.height = height
        }

        Storage.setItem('width', this.embedVideo.width)
        Storage.setItem('height', this.embedVideo.height)

        this.fetching = false
        this.video = videoItem

        if (this.embed) this.handleShowLink(this.embed)
      }

      if (externalOption) option = externalOption
      Storage.setItem('embedType', option)
    },
    handleOpenDubModal() {
      if (!this.selectedItems.length) return
      this.$root.$emit('openBatchDubModal')
    },
    handleOpenSubModal() {
      if (!this.selectedItems.length) return
      this.$root.$emit('openBatchSubModal')
    },
  },
  mounted() {
    this.authToken = Storage.getItem('accessToken')
    this.embedSelected = ''
    let storageEmbedOption = Storage.getItem('embedType') ?? 'general'
    if (!storageEmbedOption) Storage.setItem('embedType', 'general')
    this.embedSelected = storageEmbedOption.toLowerCase()
    this.setEmbed(
      Storage.getItem('embedType') ??
        i18n.t('message.pages.videoEditModal.embedConfiguration.default')
    )
  },
}
</script>
<style lang="scss">
.sectionStyle {
  background-color: #ebedff;
  color: var(--v-neutral-base);
  display: flex;
  border-radius: 24px;
  padding-left: 2px;
  padding-right: 2px;
  justify-content: center;
  font-size: small;
  font-weight: 500;
}
</style>
